import { Component, Input, OnInit, OnChanges } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";

import {
  faTrash,
  faEdit,
  faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons";
import { faGripDotsVertical } from "@fortawesome/pro-light-svg-icons";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { ConfigureSeriesComponent } from "@dialogs/configure-series/configure-series.component";
import { environment } from "@environments/environment";

@Component({
    selector: "app-series",
    templateUrl: "./series.component.html",
    styleUrls: ["./series.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class SeriesComponent implements OnInit, OnChanges {
  @Input() currentDataFields!: any;
  @Input() appliedSeries!: any;
  @Input() chartType!: any;
  @Input() chartData!: any;
  childForm: any;
  public fieldForm!: UntypedFormGroup;
  public aggregateData: any = [];
  public seriesFields: any[] = [];

  faEdit = faEdit;
  faTrash = faTrash;
  faTriangleExclamation = faTriangleExclamation;
  faGripDotsVertical = faGripDotsVertical;
  seriesDefault = "";
  selectedIndex = -1;
  showSeriesAlert = false;

  constructor(
    public parentF: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private canvasService: CanvasService,
    public commonService: CommonService,
    public dialog: MatDialog
  ) {}

  get grouplist(): UntypedFormArray {
    return this.fieldForm.get("groupby") as UntypedFormArray;
  }

  configureSeries(event: any, index: number, field: any) {
    if (event) event.stopPropagation();

    if (this.chartType != "Pie") {
      this.selectSeries(true, index);
      const elem = "seriesRight-" + index;
      const element = document.getElementById(elem);
      const rect = element
        ? element.getBoundingClientRect()
        : { top: 0, left: 0 };

      let dialogRef: any = this.dialog;

      if (rect.top == 0) {
        dialogRef = this.dialog.open(ConfigureSeriesComponent, {
          width: "500px",
          disableClose: true,
          data: {
            message: "Configure this series",
            field: field,
            currentDataFields: this.currentDataFields,
          },
          panelClass: "canvas-dialog",
        });
      } else {
        dialogRef = this.dialog.open(ConfigureSeriesComponent, {
          width: "500px",
          disableClose: true,
          data: {
            message: "Configure this series",
            field: field,
            currentDataFields: this.currentDataFields,
          },
          panelClass: ["canvas-dialog", "dialog-right"],
          position: { top: rect.top - 50 + "px", left: rect.left - 520 + "px" },
        });
      }

      dialogRef.afterClosed().subscribe((result: any) => {
        this.selectSeries(false, index);
        if (result) {
          if (result) {
            this.seriesFields[index] = result;
            this.buildAggregateData();
          }
        }
        this.fieldForm.get("selectItem")!.setValue("");
      });
    }
  }

  choosePlaceholder() {
    let placeholder = "Choose Field to add Series";
    this.showSeriesAlert = false;
    if (this.chartType == "Pie" && this.seriesFields.length == 1) {
      placeholder = "Only 1 Series can be added";
    } else {
      if (this.seriesFields.length >= 15) {
        placeholder = "Only 15 Series can be visible";
        if (this.currentDataFields.length > 15) this.showSeriesAlert = true;
      }
    }
    return placeholder;
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex != event.currentIndex) {
      // this.childForm.get("drilldownEnabled").setValue(false);
      moveItemInArray(
        this.seriesFields,
        event.previousIndex,
        event.currentIndex
      );
      this.buildAggregateData();
    }
  }
  isInCurrentSeriesList(id: any) {
    let found = false;
    const field = this.seriesFields.find((x: any) => x.id === id);
    if (field) found = true;
    return found;
  }

  getbreakDownDataPointIdName(id: any) {
    const breakDownDataPointId = this.currentDataFields.filter((item: any) => {
      return item.id == id;
    });

    if (breakDownDataPointId[0]) {
      return "By " + breakDownDataPointId[0].name;
    } else {
      return "";
    }
  }

  removeDataField(event: any, index: number) {
    const elem = "seriesRight-" + index;
    this.selectSeries(true, index);
    const element = document.getElementById(elem);
    let messageDetail = "";
    this.selectField(true, index);
    const rect = element
      ? element.getBoundingClientRect()
      : { top: 0, left: 0 };

    if (event) {
      event.stopPropagation();
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: "Remove this series?",
          messageDetail: messageDetail,
          actionButton: "remove",
        },
        panelClass: ["canvas-dialog", "dialog-right"],
        position: { top: rect.top - 50 + "px", left: rect.left - 380 + "px" },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.selectSeries(false, index);
        if (result) {
          this.seriesFields.splice(index, 1);
          this.buildAggregateData();
        }
      });
    }
  }
  seriesSelectDisabled() {
    if (this.chartType == "Pie") {
      if (this.seriesFields.length >= 1) return true;
      else return false;
    } else {
      if (this.seriesFields.length >= 15) return true;
      else return false;
    }
  }
  selectField(condition: boolean, fieldID: any) {
    if (condition) {
      this.selectedIndex = fieldID;
    } else {
      this.selectedIndex = -1;
    }
  }
  isOptionDisabled(opt: any): boolean {
    return (
      this.fieldForm.get("fields")!.value.length >= 1 &&
      !this.fieldForm.get("fields")!.value.find((el: any) => el == opt)
    );
  }

  buildAggregateData() {
    const visibleDataPointIds: any = [];
    const series: any = [];
    let data: any;
    this.seriesFields.forEach((element: any) => {
      visibleDataPointIds.push(element.id);
      if (element.breakDownDataPointId) {
        if (element.breakDownDataPointId == 0)
          element.breakDownDataPointId = null;
        data = {
          dataPointId: element.id,
          breakDownDataPointId: element.breakDownDataPointId,
        };
      } else {
        data = {
          dataPointId: element.id,
          breakDownDataPointId: null,
        };
      }
      series.push(data);
    });
    this.childForm.get("appliedSeries")!.setValue(series);

    // make refresh call and emit the chart data to the parent
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        this.canvasService.populateCanvas(data);
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        this.canvasService.populateCanvas(data);
      }
    );
  }

  initForm() {
    this.fieldForm = this.fb.group({
      selectItem: new UntypedFormControl(""),
      field: new UntypedFormControl(""),
      fields: new UntypedFormControl([]),
      conditions: this.fb.array([]),
    });
  }

  populateVisibleList() {
    this.seriesFields = [];
    if (this.appliedSeries) {
      this.appliedSeries.forEach((element: any) => {
        const id = element.dataPointId;
        const breakDownDataPointId = element.breakDownDataPointId;
        this.fieldForm.get("selectItem")!.setValue(id);
        this.addSeries(true, breakDownDataPointId);
      });
    }
  }

  addSeries(init?: boolean, breakDownDataPointId?: any) {
    let selected = this.fieldForm.get("selectItem")!.value;
    const itemtoMove = this.currentDataFields.filter((item: any) => {
      return item.id == selected;
    });
    if (itemtoMove[0]) {
      const field = JSON.parse(JSON.stringify(itemtoMove[0]));
      field.breakDownDataPointId = breakDownDataPointId || null;

      this.seriesFields.push(field);
      if (!init) this.buildAggregateData();
    }
    this.fieldForm.get("selectItem")!.setValue("");
  }

  selectSeries(condition: boolean, seriesID: any) {
    if (condition) {
      this.selectedIndex = seriesID;
    } else {
      this.selectedIndex = -1;
    }
  }

  ngOnChanges() {
    this.childForm = this.parentF.form;

    setTimeout(() => {
      if (this.fieldForm) {
        this.populateVisibleList();
      }
    }, 10);
  }

  ngOnInit(): void {
    this.initForm();
    this.populateVisibleList();
    this.childForm = this.parentF.form;
  }
}
